<template>
  <div class="sm-confirm">
    <h4>{{title}}</h4>
    <slot name="content"></slot>
    <p v-if="text.length">{{text}}</p>
    <slot></slot>
    <div class="sm-confirm__flex">
      <btn-block 
        :class="'sm-btn--small sm-btn--grey-cut'" 
        :text="cancelText"
        @click="$emit('cancel')"
      />
      <btn-block 
        :class="`sm-btn--small sm-btn--${confirmType}`" 
        :text="confirmText"
        @click="$emit('confirm')"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'confirm-block',
  props: {
    title: {
      type: String,
      default: 'Are you sure?'
    },
    text: {
      type: String,
      default: ''
    },
    confirmText: {
      type: String,
      default: 'Confirm'
    },
    confirmType: {
      type: String,
      default: 'green' // btn types
    },
    cancelText: {
      type: String,
      default: 'Cancel'
    }
  }
}
</script>

<style lang="scss">
  .sm-confirm {
    & > p {
      margin-top: 12px;
      overflow: hidden;
    }

    &__flex {
      display: flex;
      margin-top: 24px;

      & > button {
        width: calc(50% - 10px);

        &:first-child {
          margin-right: 20px;
        }
      }
    }
  }
</style>